import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Colors} from '@entities/common/common.enums';
import {Page, SubPage, Vendor} from '@entities/left-panel/left-panel.interface';
import {LeftPanelHelper} from '@shared/helpers/left-panel.helper';
import {DataStorageHelper, LogoutService, UserPermissionsHelper} from 'amc-common-components';

/**
 * Header component.
 * @class
 */
@Component({
	selector: 'mdm-header-component',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
	/**
	 * Input variable for providing 'selected page' value to component from parent.
	 */
	@Input() readonly selectedPage: Page;
	/**
	 * Input variable for providing 'selected sub page' value to component from parent.
	 */
	@Input() readonly selectedSubPage: SubPage;
	/**
	 * Input variable for providing 'selected vendor' value to component from parent.
	 */
	@Input() readonly selectedVendor: Vendor;
	/**
	 * Input variable for providing 'user name' value to component from parent.
	 */
	@Input() readonly userName: string;

	/** Auxiliary 'colors' variable. */
	public readonly colors = Colors;
	/** Auxiliary 'DataStorageHelper' variable. */
	public readonly DataStorageHelper = DataStorageHelper;
	/** Auxiliary 'hasPermission' variable. */
	public readonly hasPermission = UserPermissionsHelper.hasPermission('MAPPING');
	/** Auxiliary 'pageIds' variable. */
	public readonly pageIds = LeftPanelHelper.PAGE_IDS;

	/**
	 * Constructor for HeaderComponent.
	 */
	constructor(private logoutService: LogoutService) {}

	/**
	 * Logout.
	 * @returns {void}
	 */
	public logout(): void {
		this.logoutService.logout(true);
	}
}
